const fetchRecommendations = ({ http, params = {} }) => http({
  url: '/recommendedJobOffers',
  params: {
    offset: 0,
    limit: 15,
    source: 'pracujpl',
    ...params
  }
})
  .then(({ data }) => data)
  .then(offers => (Array.isArray(offers) ? offers.map(offer => ({
    ...offer,
    isOneClickApply: Boolean(offer.oneClickApply)
  })) : []));

export default fetchRecommendations;
